const TaskMoveProductsType = {
    COLLAPSE: 0,
    DISTRIBUTE: 1,
    RELOCATE: 2,
    MANYTOMANY: 3
};

export {TaskMoveProductsType};
